/* unplugin-vue-components disabled */import script from "./Contact.vue?vue&type=script&setup=true&lang=js"
export * from "./Contact.vue?vue&type=script&setup=true&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=57b1565a&lang=scss"

const __exports__ = script;

export default __exports__